import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import SignInApi from "@/api/my/signIn";
import i18n from "@/i18n";
import { languages, savedLanguage } from "@/i18n/languages";
let signInHttp = new SignInApi();
let signIn = null;
let signInTime = 0;
let signInArr = [];

Vue.use(VueRouter);

const routes = [
  {
    name: 'contact',
    path: '/contact',
    meta: { titleKey: 'contact.title', isNeedLogin: false },
    component: () => import('@/views/platform/contact.vue'),
  },
  {
    path: "/login",
    name: "login",
    meta: { titleKey: "login.title", isNeedLogin: false },
    component: () => import("@/views/home/login.vue"),
  },
  {
    path: "/register",
    name: "register",
    meta: { titleKey: "register.title", isNeedLogin: false },
    component: () => import("@/views/home/register.vue"),
  },
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    meta: { titleKey: "forgotPassword.title", isNeedLogin: false },
    component: () => import("@/views/home/forgotPassword.vue"),
  },
  {
    path: '/',
    redirect: '/market',
    component: () => import("@/layout/index"),
    children: [
      {
        name: 'market',
        path: '/market',
        meta: { titleKey: "shell.pages.market", isNeedLogin: false },
        component: () => import("@/views/market/index"),
      },
      {
        name: 'platform',
        path: '/platform',
        meta: { titleKey: "shell.pages.platform", isNeedLogin: false },
        component: () => import("@/views/platform/index"),
      }, 
      {
        name: 'manyEmpty',
        path: '/manyEmpty',
        meta: { titleKey: "shell.pages.manyEmpty", isNeedLogin: false },
        component: () => import("@/views/manyEmpty/index"),
      },
      {
        name: 'whale',
        path: '/whale',
        meta: { titleKey: "shell.pages.whale", isNeedLogin: false },
        component: () => import("@/views/whale/index"),
      },
      {
        name: 'burst',
        path: '/burst',
        meta: { titleKey: "shell.pages.burst", isNeedLogin: false },
        component: () => import("@/views/burst/index"),
      },
      {
        name: 'calendar',
        path: '/calendar',
        meta: { titleKey: "shell.pages.calendar", isNeedLogin: false },
        redirect: { name: 'consult', query: { tab: 'calendar' } },
      },

      {
        name: 'burstHeatmapDetails',
        path: '/burstHeatmapDetails',
        meta: { titleKey: "burstHeatmapDetails.title", isNeedLogin: false },
        component: () => import("@/views/burst/heatmapDetails"),
      },
      {
        name: 'burstCoinStatisticsDetails',
        path: '/burstCoinStatisticsDetails',
        meta: { titleKey: "burstCoinStatisticsDetails.title", isNeedLogin: false },
        component: () => import("@/views/burst/coinStatisticsDetails"),
      },
      {
        name: 'hyperliquid',
        path: '/hyperliquid',
        meta: { titleKey: "shell.pages.hyperliquid", isNeedLogin: false },
        component: () => import("@/views/hyperliquid/index"),
      },
      {
        name: 'hyperliquidDetails',
        path: '/hyperliquidDetails/:user',
        meta: { titleKey: "shell.pages.hyperliquidDetails", isNeedLogin: false },
        component: () => import("@/views/hyperliquid/details"),
      },
      {
        name: 'rate',
        path: '/rate',
        meta: { titleKey: "shell.pages.rate", isNeedLogin: false },
        component: () => import("@/views/rate/index"),
      },
      {
        name: 'application',
        path: '/application',
        meta: { titleKey: "shell.pages.application", isNeedLogin: false },
        component: () => import("@/views/application/index"),
      },
      {
        name: "publicChain",
        path: "/publicChain",
        meta: { titleKey: "shell.pages.publicChain", isNeedLogin: false },
        component: () => import("@/views/publicChain/index"),
      },
      {
        name: "newChain",
        path: "/newChain",
        meta: { titleKey: "shell.pages.newChain", isNeedLogin: false },
        component: () => import("@/views/newChain/index"),
      },
      {
        name: "inscription",
        path: "/inscription",
        meta: { titleKey: "shell.pages.inscription", isNeedLogin: false },
        component: () => import("@/views/inscription/index"),
      }, 
      {
        name: "consult",
        path: "/consult",
        meta: { titleKey: "shell.pages.consult", isNeedLogin: false },
        component: () => import("@/views/consult/index"),
      },
      // {
      //   name: "okxswap",
      //   path: "/okxswap",
      //   meta: { title: '交换代币', isNeedLogin: false },
      //   component: () => import("@/views/firmOffer/okxSwapWidget.vue"),
      // },
      {
        name: "solswap",
        path: "/solswap",
        meta: { titleKey: "swap.title", isNeedLogin: false },
        component: () => import("@/views/firmOffer/solswap.vue"),
      },
    ]
  },
  {
    path: '/',
    component: () => import("@/layout/indexNoHeader"),
    children: [
      {
        name: 'my',
        path: '/my',
        meta: { titleKey: "shell.pages.my", isNeedLogin: false },
        component: () => import("@/views/my/index"),
      },
      {
        name: 'signIn',
        path: '/signIn',
        meta: { titleKey: "signIn.title", isNeedLogin: true },
        component: () => import("@/views/my/signIn"),
      },
      {
        name: 'signInRecord',
        path: '/signInRecord',
        meta: { titleKey: "signInRecord.title", isNeedLogin: true },
        component: () => import("@/views/my/signInRecord"),
      },
      {
        name: 'contractCheck',
        path: '/contractCheck',
        meta: { titleKey: "shell.pages.contractCheck", isNeedLogin: true },
        component: () => import("@/views/my/contractCheck"),
      },
      {
        name: 'withdrawal',
        path: '/withdrawal',
        meta: { titleKey: "withdrawal.title", isNeedLogin: true },
        component: () => import("@/views/my/withdrawal"),
      },
      {
        name: 'withdrawalRecord',
        path: '/withdrawalRecord',
        meta: { titleKey: "withdrawalRecord.title", isNeedLogin: true },
        component: () => import("@/views/my/withdrawalRecord"),
      },
      {
        name: 'invite',
        path: '/invite',
        meta: { titleKey: "invite.title", isNeedLogin: true },
        component: () => import("@/views/my/invite"),
      },
      {
        name: 'bindingApi',
        path: '/bindingApi',
        meta: { titleKey: "bindingApi.title", isNeedLogin: true },
        component: () => import("@/views/my/bindingApi"),
      },
      {
        name: 'hitNewRobot',
        path: '/hitNewRobot',
        meta: { titleKey: "shell.pages.hitNewRobot", isNeedLogin: false },
        component: () => import("@/views/my/hitNewRobot"),
      },
      {
        name: 'userHitNewRobotInfo',
        path: '/userHitNewRobotInfo',
        meta: { titleKey: "hitNewRobotInfo.title", isNeedLogin: false },
        component: () => import('@/views/my/hitNewRobotInfo'),
      },
      {
        name: 'hitNewRobotRule',
        path: '/hitNewRobotRule',
        meta: { titleKey: "hitNewRobotRule.title", isNeedLogin: false },
        component: () => import("@/views/my/hitNewRobotRule"),
      },
      // {
      //   name: 'myAsset',
      //   path: '/myAsset',
      //   meta: { title: '我的-我的资产', isNeedLogin: true },
      //   component: () => import("@/views/my/myAsset"),
      // },
      {
        name: 'collect',
        path: '/collect',
        meta: { titleKey: "shell.pages.collect", isNeedLogin: true },
        component: () => import("@/views/my/collect"),
      },
      {
        name: 'trace',
        path: '/trace',
        meta: { titleKey: "shell.pages.trace", isNeedLogin: true },
        component: () => import("@/views/my/trace"),
      },
      {
        name: 'userDelete',
        path: '/userDelete',
        meta: { titleKey: "userDelete.title", isNeedLogin: true },
        component: () => import("@/views/my/user-delete"),
      },
      {
        name: 'team',
        path: '/team',
        meta: { titleKey: "team.title", isNeedLogin: true },
        component: () => import("@/views/my/team"),
      }, 
      {
        name: "forum",
        path: "/forum",
        meta: { titleKey: "shell.pages.forum", isNeedLogin: false },
        component: () => import("@/views/my/forum"),
      },
      {
        name: "forumPublish",
        path: "/forumPublish",
        meta: { titleKey: "forumPublish.title", isNeedLogin: false },
        component: () => import("@/views/my/forumPublish"),
      },
      {
        name: "forumDetails",
        path: "/forumDetails/:forumId",
        meta: { titleKey: "forumDetails.title", isNeedLogin: false },
        component: () => import("@/views/my/forumDetails"),
      },
      {
        name: "tool",
        path: "/tool",
        meta: { titleKey: "shell.pages.tool", isNeedLogin: false },
        component: () => import("@/views/my/tool"),
      },
      {
        name: "toolCompanyHoldings",
        path: "/toolCompanyHoldings",
        meta: { titleKey: "shell.pages.toolCompanyHoldings", isNeedLogin: false },
        component: () => import("@/views/tool/companyHoldings"),
      },
      {
        name: "toolSentimentIndex",
        path: "/toolSentimentIndex",
        meta: { titleKey: "shell.pages.toolSentimentIndex", isNeedLogin: false },
        component: () => import("@/views/tool/sentimentIndex"),
      },
      {
        name: "toolMTGoxMonitor",
        path: "/toolMTGoxMonitor",
        meta: { titleKey: "shell.pages.toolMTGoxMonitor", isNeedLogin: false },
        component: () => import("@/views/tool/MTGoxMonitor"),
      },
      {
        name: "toolOutsidePrice",
        path: "/toolOutsidePrice",
        meta: { titleKey: "shell.pages.toolOutsidePrice", isNeedLogin: false },
        component: () => import("@/views/tool/outsidePrice"),
      },
      {
        name: "toolOutsideDisk",
        path: "/toolOutsideDisk",
        meta: { titleKey: "shell.pages.toolOutsideDisk", isNeedLogin: false },
        component: () => import("@/views/tool/outsideDisk"),
      },
      {
        name: "toolLargeIncrease",
        path: "/toolLargeIncrease",
        meta: { titleKey: "shell.pages.toolLargeIncrease", isNeedLogin: false },
        component: () => import("@/views/tool/largeIncrease"),
      },
      {
        name: "toolLargeDecrease",
        path: "/toolLargeDecrease",
        meta: { titleKey: "shell.pages.toolLargeDecrease", isNeedLogin: false },
        component: () => import("@/views/tool/largeDecrease"),
      },
      {
        name: "toolStableCoin",
        path: "/toolStableCoin",
        meta: { titleKey: "shell.pages.toolStableCoin", isNeedLogin: false },
        component: () => import("@/views/tool/stableCoin"),
      },
      {
        name: "toolBlockChainBrowser",
        path: "/toolBlockChainBrowser",
        meta: { titleKey: "shell.pages.toolBlockChainBrowser", isNeedLogin: false },
        component: () => import("@/views/tool/blockChainBrowser"),
      },
      {
        name: "externalLink",
        path: "/externalLink",
        meta: { titleKey: "appShell.externalLink", isNeedLogin: false },
        component: () => import("@/views/externalLink/index"),
      },
      {
        name: 'calendarDetail',
        path: '/calendarDetail/:id',
        meta: { titleKey: "calendar_details.title", isNeedLogin: false },
        component: () => import("@/views/calendar/detail"),
      },
      {
        name: "consultDetails",
        path: "/consultDetails/:id/:type",
        meta: { titleKey: "consultDetails.title", isNeedLogin: false },
        component: () => import("@/views/consult/details"),
      },
      {
        name: "coinDetails",
        path: "/coinDetails",
        meta: { titleKey: "coinDetails.title", isNeedLogin: false },
        component: () => import("../components/coinDetails"),
      },
      {
        name: "newCoinDetails",
        path: "/newCoinDetails",
        meta: { titleKey: "newCoinDetails.title", isNeedLogin: false },
        component: () => import("../components/newCoinDetails"),
      },
      {
        name: "platformDetails",
        path: "/platformDetails",
        meta: { titleKey: "platformDetails.title", isNeedLogin: false },
        component: () => import("../components/platformDetails"),
      },
      {
        name: "insdetail",
        path: "/insdetail",
        meta: { titleKey: "insdetail.title", isNeedLogin: false },
        component: () => import("@/views/inscription/insdetail"),
      },
      {
        name: "firmOffer",
        path: "/firmOffer",
        meta: { titleKey: "firmOffer.title", isNeedLogin: false },
        component: () => import("@/views/firmOffer/index.vue"),
      }
    ]
  },
];

const router = new VueRouter({
  // mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

let a = 0;
let getIpOrLanguage = (to, next, t) => {
  const xhr = new XMLHttpRequest();
  xhr.open('get', 'https://api.ipify.org');
  xhr.send();
  xhr.onreadystatechange = function() {
    if (xhr.readyState == 4 && xhr.status == 200) {
      store.commit('SET_IP', xhr.responseText);
      const xhr2 = new XMLHttpRequest();
      xhr2.open('get', `https://ipinfo.io/${xhr.responseText}/json`);
      xhr2.send();
      xhr2.onreadystatechange = function() {
        if (xhr2.readyState == 4 && xhr2.status == 200) {
          let xhr2Response = JSON.parse(xhr2.responseText)
          // if (!store.state.language?.type) {
          if (t === 0 && !savedLanguage()) {
            const country = xhr2Response.country;
            const locale = country === 'CN' ? 'zh_CN'
              : ['HK', 'TW', 'MO'].includes(country) ? 'zh_TW'
              : country === 'JP' ? 'ja_JP' : country === 'KR' ? 'ko_KR' : 'en_US';
            const language = languages.find(item => item.type === locale);
            store.commit('SET_LANGUAGE', language);
            i18n.locale = locale;
          }
        }
      }
    }
  }
  if (t == 0) {
    if (to.meta.isNeedLogin && !store.state.token) {
      next({ path: '/login', query: { redirect: to.fullPath } });
    } else {
      next();
    }
  }
};

router.beforeEach((to, from, next) => {
  if (a == 0) {
    getIpOrLanguage(to, next, 0);
  } else {
    if (to.meta.isNeedLogin && !store.state.token) {
      next({ path: '/login', query: { redirect: to.fullPath } });
    } else {
      next();
    }
    getIpOrLanguage(to, next, 1);
  }
  a = 1;
})

router.afterEach((to, from) => {
  if (store.state.token) {
    if (!signInArr.includes(from.name)) {
      signInHttp.signInCount({num: signInTime});
      clearInterval(signIn);
    }
    if (!signInArr.includes(to.name)) {
      signInTime = 0;
      signIn = setInterval(() => {
        signInTime += 1;
      }, 1000);
    }
  }
})

export default router;
